define('constants/audioFileConversionStatusConstants',[], function() {
    return {
        pending: 0,
        converted: 1,
        conversionError: 2
    };
});
